import { memo } from 'react'
import { shallow } from 'zustand/shallow'
import { useReportStore } from '@/modules/report/useReportsStore'
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from '@/modules/shared/components/ui/table'
import { Card, CardContent, CardHeader, CardTitle } from '@/modules/shared/components/ui/card'
import { priceFormatter } from '@/modules/shared/utils/formatter'

export default memo(function ListSalesByProductReport() {
	const { loading, jsonSalesByProduct } = useReportStore(
		(state) => ({
			loading: state.loading,
			jsonSalesByProduct: state.jsonSalesByProduct,
		}),
		shallow,
	)

	// Calculate totals with safe number conversion
	const totals = jsonSalesByProduct?.produtos?.reduce(
		(acc, item) => ({
			quantidade: acc.quantidade + (Number(item.quantidade) || 0),
			qtdEmbalagem: acc.qtdEmbalagem + (Number(item.qtdEmbalagem) || 0),
			volume: acc.volume + (Number(item.volume) || 0),
			valor: acc.valor + (Number(item.valor) || 0),
		}),
		{ quantidade: 0, qtdEmbalagem: 0, volume: 0, valor: 0 },
	) || { quantidade: 0, qtdEmbalagem: 0, volume: 0, valor: 0 }

	// Format number to 2 decimal places
	const formatNumber = (value) => {
		return isNaN(value) ? '0.00' : Number(value).toFixed(2)
	}

	return (
		<div>
			{!loading && jsonSalesByProduct?.produtos?.length > 0 && (
				<Card>
					<CardHeader>
						<CardTitle className="text-lg">Lista Produto x Valor</CardTitle>
					</CardHeader>
					<CardContent>
						{/* Mobile view: Cards */}
						<div className="md:hidden space-y-4">
							<Card>
								<CardContent className="pt-4">
									<p className="font-bold text-right">Totais:</p>
									<div className="mt-2 space-y-1 text-sm">
										<p>Quantidade: {formatNumber(totals.quantidade)}</p>
										<p>Qtd Embalagem: {formatNumber(totals.qtdEmbalagem)}</p>
										<p>Volume: {formatNumber(totals.volume)}</p>
										<p>Valor: {priceFormatter.format(totals.valor)}</p>
									</div>
								</CardContent>
							</Card>
							{jsonSalesByProduct?.produtos?.map((item) => (
								<Card key={item.referencia}>
									<CardContent className="pt-4">
										<p className="font-bold">{item.referencia} - {item.descricao}</p>
										<div className="mt-2 space-y-1 text-sm">
											<p>Quantidade: {formatNumber(item.quantidade)}</p>
											<p>Qtd Embalagem: {formatNumber(item.qtdEmbalagem)}</p>
											<p>Volume: {formatNumber(item.volume)}</p>
											<p>Valor: {priceFormatter.format(item.valor)}</p>
										</div>
									</CardContent>
								</Card>
							))}
						</div>

						{/* Desktop view: Table */}
						<div className="hidden md:block">
							<Table>
								<TableHeader>
									<TableRow>
										<TableHead>Referência</TableHead>
										<TableHead>Descrição</TableHead>
										<TableHead>Quantidade</TableHead>
										<TableHead>Qtd Embalagem</TableHead>
										<TableHead>Volume</TableHead>
										<TableHead>Valor</TableHead>
									</TableRow>
								</TableHeader>
								<TableBody>

									{jsonSalesByProduct?.produtos?.map((item) => (
										<TableRow key={item.referencia}>
											<TableCell>{item.referencia}</TableCell>
											<TableCell className="font-bold">{item.descricao}</TableCell>
											<TableCell>{formatNumber(item.quantidade)}</TableCell>
											<TableCell>{formatNumber(item.qtdEmbalagem)}</TableCell>
											<TableCell>{formatNumber(item.volume)}</TableCell>
											<TableCell>{priceFormatter.format(item.valor)}</TableCell>
										</TableRow>
									))}
									<TableRow>
										<TableCell colSpan={2} className="text-right font-bold">
											Totais:
										</TableCell>
										<TableCell className="font-bold">{formatNumber(totals.quantidade)}</TableCell>
										<TableCell className="font-bold">{formatNumber(totals.qtdEmbalagem)}</TableCell>
										<TableCell className="font-bold">{formatNumber(totals.volume)}</TableCell>
										<TableCell className="font-bold">{priceFormatter.format(totals.valor)}</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</div>
					</CardContent>
				</Card>
			)}
		</div>
	)
})